
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/about/overview",
      function () {
        return require("private-next-pages/en/about/overview/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/about/overview"])
      });
    }
  